import { create } from "zustand"

export const useCounterStore = create((set) => ({
    camTransformId: 8,
    prev: () => set((state) => ({ camTransformId: Math.abs(state.camTransformId - 1) })),
    next: () => set((state) => ({ camTransformId: Math.abs(state.camTransformId + 1) })),
    assign: (newValue) => set((state) => ({ camTransformId: newValue })),
}))
